import { render, staticRenderFns } from "./TabPrecoSelectModal.vue?vue&type=template&id=6b08b5d7&scoped=true"
import script from "./TabPrecoSelectModal.vue?vue&type=script&lang=js"
export * from "./TabPrecoSelectModal.vue?vue&type=script&lang=js"
import style0 from "./TabPrecoSelectModal.vue?vue&type=style&index=0&id=6b08b5d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b08b5d7",
  null
  
)

export default component.exports